import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAppStore, useLocalStore } from '~/stores'

export const Route = createFileRoute('/profile/settings')({
  beforeLoad: async ({ location }) => {
    const { activeWorkspace } = useAppStore.getState()
    const { lastActiveWorkspaceId } = useLocalStore.getState()

    const workspaceId = activeWorkspace?.id ?? lastActiveWorkspaceId

    if (!workspaceId) {
      throw redirect({ to: '/workspaces' })
    }

    // Preserve search params if they exist
    const searchParams = location.search
    const search = Object.keys(searchParams).length > 0 ? searchParams : undefined

    throw redirect({
      to: '/workspaces/$workspaceId/profile/settings',
      params: { workspaceId },
      search,
    })
  },
})
